import { InjectedPropsType } from '@ComponentsRoot/core/types/InjectedPropsType';
import { OutletContextType } from '@ComponentsRoot/core/types/OutletContextType';
import { process } from '@progress/kendo-data-query';
import {
  Grid,
  GridColumn as Column,
  GridColumnMenuFilter,
  GridColumnMenuProps,
  GridDataStateChangeEvent,
} from '@progress/kendo-react-grid';
import { Button as GridButton } from '@progress/kendo-react-buttons';
import React from 'react';
import '@progress/kendo-theme-default/dist/all.css';
import TechnicianController from '../controller/TechnicianController';
import { Row, Col, Button, Spinner, Alert } from 'reactstrap';
import { ErrorHandler } from '@ComponentsRoot/ErrorHandler/ErrorHandler';
import { cleanGridColumnMenuIncomingPropsGridUtils } from '@MainUtils/GridUtils';

class ColumnMenu extends React.Component<GridColumnMenuProps> {
  render() {
    return (
      <div>
        <GridColumnMenuFilter {...this.props} expanded={true} />
      </div>
    );
  }
}

export default class TechnicianGridView extends React.Component<
  InjectedPropsType,
  {
    take: number;
    skip: number;
    techGridData: undefined | any[];
    techDelete: undefined | any[];
    isError: any;
    showSpinner: any;
    showSpinnerBtn: any;
    showAlert: any;
    disabledBtn: any;
  }
> {
  controller: TechnicianController;

  constructor(props: any) {
    super(props);
    this.controller = new TechnicianController(this, this.props as { outletContext: OutletContextType });

    this.state = {
      take: 20,
      skip: 0,
      techGridData: undefined,
      techDelete: undefined,
      isError: undefined,
      showSpinner: undefined,
      showSpinnerBtn: 'd-none',
      showAlert: false,
      disabledBtn: false,
    };
  }

  renderErrorHandler = () => {
    if (this.state.isError) {
      return <ErrorHandler isOpen toggle={this.controller.toggleError} message={this.state.isError.message} />;
    }
    return <></>;
  };

  componentDidMount = async () => {
    if (this.state.techGridData === undefined) {
      await this.controller.getAllTechnician();
    }
  };

  dataStateChange = (event: GridDataStateChangeEvent) => {
    this.setState({ ...(event.dataState as any) });
  };

  onDismiss = () => this.setState({ showAlert: false });

  ColumnMenuAction = (props: any) => {
    const cleanProps = cleanGridColumnMenuIncomingPropsGridUtils(props);

    return (
      <td className={props.className} {...cleanProps} style={Object.assign(props.style)}>
        <a href={`/technician/${props.dataItem.id}`}>
          <GridButton icon='pencil' fillMode='solid' className='mr-2 btn-seidor bg-seidor-light-blue color-seidor-white' />
        </a>
      </td>
    );
  };

  render() {
    return (
      <>
        <Row>
          <Col lg='12'>
            <h1>Listado de técnicos</h1>
            <Button
              className='mb-4 btn-seidor bg-seidor-medium-blue'
              disabled={this.state.disabledBtn}
              onClick={async (e: any) => await this.controller.syncTechnician()}
            >
              Sincronizar técnicos
              <Spinner size='sm' className={`spinner-pos ${this.state.showSpinnerBtn}`}>
                Loading...
              </Spinner>
            </Button>
            <Spinner color='info' className={`m-center mt-5 ${this.state.showSpinner}`}>
              Loading...
            </Spinner>
            {this.state.techGridData && (
              <Grid
                {...this.state}
                data={process(this.state.techGridData === undefined ? [] : this.state.techGridData, this.state)}
                onDataStateChange={this.dataStateChange}
                sortable={{
                  mode: 'multiple',
                }}
                pageable={true}
                pageSize={20}
              >
                <Column field='name' title='Nombre' columnMenu={ColumnMenu} />
                <Column field='surname' title='Apellidos' columnMenu={ColumnMenu} />
                <Column field='email' title='Email' columnMenu={ColumnMenu} />
                <Column title='Actions' cell={this.ColumnMenuAction} />
              </Grid>
            )}
          </Col>
        </Row>

        <Alert isOpen={this.state.showAlert} toggle={this.onDismiss} className='alert-success'>
          <p className='m-0'>
            <span className={'k-icon k-i-check-circle'}></span> Técnicos sincronizados
          </p>
        </Alert>

        {this.renderErrorHandler()}
      </>
    );
  }
}

// const checkboxCellRender = (props: any) => {
//   return (
//     <td className={props.className} {...props} style={Object.assign(props.style)}>
//       <input
//         type='checkbox'
//         checked={
//           props.dataItem[props.field] !== undefined && props.dataItem[props.field] !== null ? props.dataItem[props.field] : false
//         }
//         disabled={true}
//       />
//     </td>
//   );
// };
